export interface MfePhoneEventData {
  detail: PhoneGetData;
}

export enum PhoneValidationStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
}

export interface PhoneGetData {
  phoneNumber: string;
  isMobile: boolean;
  validationStatus: PhoneValidationStatus;
}

export interface PhoneSetData {
  phoneNumber: string;
  isMobile: boolean;
  runValidation: boolean;
}
